enum SURVEYS {
  BOOKING_EXPERIENCE = "BOOKING_EXPERIENCE",
}

export { SURVEYS };
